package com.anjuros.website.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.anjuros.website.components.BlackOverlay
import com.anjuros.website.components.TemplatesHeader
import com.anjuros.website.components.changeMode
import com.anjuros.website.components.detectLanguage
import com.anjuros.website.components.detectMode
import com.anjuros.website.components.detectMode2
import com.anjuros.website.components.language.Language
import com.anjuros.website.components.language.LanguageContext
import com.anjuros.website.components.language.LocalLanguage
import com.anjuros.website.components.language.LocalUiMode
import com.anjuros.website.components.language.UiMode
import com.anjuros.website.components.language.isContentSelected

import com.anjuros.website.components.setMeta
import com.anjuros.website.components.shared.TemplatePromoFab
import com.anjuros.website.templates.mix.modules.HintBoxDisplay
import com.anjuros.website.templates.selection.modules.Template
import com.anjuros.website.templates.template2.components.Template2OverflowMenu
import com.anjuros.website.templates.template2.sections.Template2AchievementsSection
import com.anjuros.website.templates.template2.sections.Template2ContactSection
import com.anjuros.website.templates.template2.sections.Template2FooterSection
import com.anjuros.website.templates.template2.sections.Template2MainSection
import com.anjuros.website.templates.template2.sections.Template2ReviewSection
import com.anjuros.website.templates.template2.sections.Template2Service
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.core.Page
import kotlinx.browser.localStorage
import org.jetbrains.compose.web.css.Position

@Page
@Composable
fun HandymanWebsiteDesignUk() {
    var lang by remember { mutableStateOf(Language.EN) }
    val uiMode = remember { mutableStateOf<UiMode?>(null) }
    var showModeToggleSpotlight by remember { mutableStateOf(false) }

    LaunchedEffect(Unit) {
        setMeta(
            "Handyman website design UK | Get more local jobs",
            "Website design for handymen in the UK. Simple, clear websites that help you get more local enquiries and jobs.",
            image = "https://www.soletraderwebsite.co.uk/template2_hero.jpg",
            url = "https://www.soletraderwebsite.co.uk/handyman-website-design-uk"
        )
        lang = detectLanguage()
        uiMode.value = detectMode()

        showModeToggleSpotlight =
            uiMode.value  != null && localStorage.getItem(HintBoxDisplay).isNullOrEmpty()
    }

    val languageContext = remember(lang) {
        LanguageContext(
            lang = lang,
            setLang = { lang = it }
        )
    }
    var menuOpened by remember { mutableStateOf(false) }

    val contentMode = uiMode.value?:UiMode.NORMAL
    CompositionLocalProvider(
        LocalLanguage provides languageContext,
        LocalUiMode provides contentMode
    ) {
        Box(modifier = Modifier.fillMaxSize()) {
            Column(
                modifier = Modifier.fillMaxSize(),
                verticalArrangement = Arrangement.Top,
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                Template2MainSection() {
                    menuOpened = true
                }
                Template2Service()
                Template2AchievementsSection()
                Template2ReviewSection()
                Template2ContactSection()
                Template2FooterSection()
            }
            if (showModeToggleSpotlight) {
                BlackOverlay()
            }
            TemplatesHeader(
                modifier = Modifier.align(Alignment.TopCenter)
                    .position(Position.Fixed)
                    .zIndex(100),
                template = Template.Template2,
                showModeToggleSpotlight = showModeToggleSpotlight,
                onDismissSpotlight = {
                    showModeToggleSpotlight = false
                },
                contentModeSelected = uiMode.value.isContentSelected(),
                onChangeMode = { newMode ->
                    uiMode.value = newMode
                    changeMode(newMode)
                }
            )

            if (menuOpened) {
                Template2OverflowMenu { menuOpened = false }
            }
            TemplatePromoFab()
        }
    }
}

